import { appConstants } from '../app.constant';

// F188: vendedor com conexão própria de WhatsApp no Órbita só opera conectado.
export const ORBITA_CONNECTION_ROLE = 'orbita-agent-connection';
export const ORBITA_DISCONNECTED_STATUS = 423;
export const ORBITA_DISCONNECTED_CODE = 'ORBITA_WHATSAPP_DISCONNECTED';
export const ORBITA_DISCONNECTED_EVENT = 'orbitaWhatsappDisconnected';
export const ORBITA_CONNECTION_RECHECK_MS = 30000;
export const ORBITA_RECONNECT_URL = appConstants.orbitaProfileUrl;
export const ORBITA_GATED_PATH_PREFIX = '/crm';

export const orbitaConnectionTexts = {
    title: 'Seu WhatsApp está desconectado do Órbita',
    description:
        'Para usar o Gestto, conecte o seu WhatsApp ao Órbita. Assim nenhuma conversa fica fora do histórico.',
    steps: [
        'Clique em "Abrir o Órbita".',
        'Em Meu Perfil › Conexões WhatsApp, leia o QR code com o celular.',
        'Volte para esta tela: o Gestto libera sozinho.'
    ],
    openOrbita: 'Abrir o Órbita',
    recheck: 'Já conectei',
    checking: 'Verificando...',
    stillDisconnected: 'Ainda desconectado. Leia o QR code no Órbita e tente de novo.'
};
